module.exports = __webpack_public_path__ + "img/defaultAvatar.2fce7c5d.jpg";